(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["department-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pn-department-film')) {
    customElements.define('pn-department-film', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.film = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.film || !this.button) return;
        this.preference = matchMedia('(min-width: 750px) and (prefers-reduced-motion: no-preference)');
        this.syncButton = () => {
          this.toggleAttribute('data-paused', this.film.paused);
          this.button.setAttribute('aria-label', this.film.paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel);
        };
        this.start = () => {
          this.film.muted = true;
          this.film.play().then(() => {
            if (this.isConnected && this.preference.matches && !this.userPaused) this.setAttribute('data-ready', '');
            else this.film.pause();
            this.syncButton();
          }).catch(() => {
            if (!this.hasAttribute('data-ready')) this.film.pause();
            this.syncButton();
          });
        };
        this.update = () => {
          if (!this.preference.matches) {
            this.film.pause();
            this.removeAttribute('data-ready');
          } else if (!this.userPaused) {
            this.start();
          } else {
            this.setAttribute('data-ready', '');
          }
          this.syncButton();
        };
        this.button.addEventListener('click', () => {
          if (!this.preference.matches) return;
          this.userPaused = !this.film.paused;
          if (this.userPaused) this.film.pause();
          else this.start();
          this.syncButton();
        }, options);
        this.film.addEventListener('play', this.syncButton, options);
        this.film.addEventListener('pause', this.syncButton, options);
        this.film.addEventListener('error', () => {
          this.film.pause();
          this.removeAttribute('data-ready');
        }, options);
        this.preference.addEventListener('change', this.update, options);
        this.update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.film?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pn-editorial-navigation')) {
  customElements.define('pn-editorial-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-pn-shop-parent]').forEach(link => link.addEventListener('click', event => event.stopPropagation(), options));
      const shopDropdown = this.querySelector('.pn-nav-shop-dropdown');
      if (shopDropdown) {
        const summary = shopDropdown.querySelector('summary');
        const shopControl = shopDropdown.parentElement;
        let closeTimer;
        let openedByHover = false;
        const closeShop = () => { clearTimeout(closeTimer); openedByHover = false; shopDropdown.open = false; };
        const hoverCapable = () => window.matchMedia('(hover:hover) and (pointer:fine)').matches;
        shopControl.addEventListener('pointerenter', () => { if (hoverCapable()) { clearTimeout(closeTimer); openedByHover = !shopDropdown.open; shopDropdown.open = true; } }, options);
        shopControl.addEventListener('pointerleave', () => { if (hoverCapable()) closeTimer = setTimeout(() => { if (!shopControl.contains(document.activeElement)) closeShop(); }, 180); }, options);
        summary.addEventListener('click', event => { if (openedByHover && event.detail !== 0) { event.preventDefault(); openedByHover = false; shopDropdown.open = true; } }, options);
        shopDropdown.addEventListener('keydown', event => {
          if (event.key === 'Escape' && shopDropdown.open) { event.preventDefault(); closeShop(); summary.focus(); }
        }, options);
        shopDropdown.addEventListener('focusout', event => { if (!shopControl.contains(event.relatedTarget)) closeShop(); }, options);
        document.addEventListener('click', event => { if (!shopControl.contains(event.target)) closeShop(); }, options);
        window.addEventListener('scroll', closeShop, { ...options, passive:true });
        window.addEventListener('resize', closeShop, options);
      }

      const update = () => { this.toggleAttribute('data-compact', this.getBoundingClientRect().top <= 64); this.frame = 0; };
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('load', this.schedule, options);
      this.querySelectorAll('[data-pn-panel]').forEach(button => button.addEventListener('click', () => {
        const panel = this.querySelector('#pn-nav-' + button.dataset.pnPanel);
        this.returnFocus = button;
        panel.showModal();
        document.documentElement.classList.add('pn-nav-dialog-open');
        button.setAttribute('aria-expanded', 'true');
        if (button.dataset.pnPanel === 'search') panel.querySelector('input').focus();
      }, options));
      this.querySelectorAll('dialog').forEach(panel => {
        panel.querySelector('[data-pn-close]').addEventListener('click', () => panel.close(), options);
        panel.addEventListener('click', event => { const r = panel.getBoundingClientRect(); if (event.target === panel && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) panel.close(); }, options);
        panel.addEventListener('close', () => { document.documentElement.classList.remove('pn-nav-dialog-open'); if (this.returnFocus) { this.returnFocus.setAttribute('aria-expanded', 'false'); this.returnFocus.focus({preventScroll: true}); } }, options);
      });
      update();
    }
    disconnectedCallback() { this.querySelectorAll('dialog[open]').forEach(panel => panel.close()); this.abort.abort(); if (this.frame) cancelAnimationFrame(this.frame); document.documentElement.classList.remove('pn-nav-dialog-open'); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-subscribe"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-pn-subscribe]');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    let delay = 0;
    if (drawer) {
      const summary = drawer.querySelector('details[open] > summary');
      if (summary) { summary.click(); delay = 450; }
    }
    if (!window._klOnsite) return;
    event.preventDefault();
    window.setTimeout(function() {
      window._klOnsite.push(['openForm', 'TZfSEa']);
    }, delay);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pn-advent-award-marks-2026"] && !Shopify.designMode) return;
  try {
    (function(){
  var root=document.getElementById('pn-advent-2026');
  if(!root)return;
  function reveal(hash){
    var target=hash&&document.getElementById(hash.slice(1));
    if(!target||!root.contains(target))return;
    var view=target.closest('[data-pn-view]');
    if(view){
      var tab=root.querySelector('[data-pn-tab="'+view.getAttribute('data-pn-view')+'"]');
      if(tab&&tab.getAttribute('aria-selected')!=='true')tab.click();
    }
    requestAnimationFrame(function(){target.scrollIntoView({block:'start'});});
  }
  root.querySelectorAll('[data-pn-mark-view]').forEach(function(link){
    link.addEventListener('click',function(event){
      event.preventDefault();
      var hash=link.getAttribute('href');
      history.replaceState(null,'',hash);
      reveal(hash);
    });
  });
  window.addEventListener('hashchange',function(){reveal(location.hash);});
  if(location.hash==='#pn-official-award-marks')reveal(location.hash);
})();
  } catch(e) { console.error(e); }
})();

})();
